import { ChangeEvent } from 'react'
import _ from 'lodash'
import {
	L2TabularListRoot,
	L2TabularListHeader,
	L2TabularListContent,
	L2TabularListActions,
} from '../l2/L2TabularList'
import {
	L2TabularListItemSummary,
	L2TabularListItemEdit,
	L2TabularListControl,
	L2TabularListControlLabel,
	L2TabularListEditBreak,
} from '../l2/L2TabularListItem'
import L1Boolean from '../l1/L1Boolean'
import L1TextField from '../l1/L1TextField'
import L2ControlGrid from '../l2/L2ControlGrid'
import { L1ReasonableButton } from '../l1/L1Button'
import { faPlus } from '@fortawesome/pro-regular-svg-icons'
import { useL4TabularStateReturn } from '../l4/L4TabularList'
import { L4NoPrint } from '../l4/L4Print'
import { newPhysician, Physician } from '@fusion-advantage/formlib'
import L2ControlGridLayout from '../l2/L2ControlGridLayout'
import { ComplexElementSize } from '../ComplexElementSize'

type L3PhysicianListProps = {} & useL4TabularStateReturn<Physician>

export const L3PhysicianList = ({models, addModels, updateModel, deleteModel, editIdx, setEditIdx}: L3PhysicianListProps) => {
	const items = _.map(models, (model, modelIdx) => {
		if(editIdx === modelIdx) {
			return (
				<L2TabularListItemEdit
					key={modelIdx}
					onCloseClick={() => setEditIdx(null)}
					onDeleteClick={() => deleteModel(modelIdx)}
				>
					<L2TabularListControl>
						<L2TabularListControlLabel>Is PCP</L2TabularListControlLabel>
						<L1Boolean
							inputType="checkbox"
							label="Yes"
							checked={model.IsPCP}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'IsPCP', e.target.checked)}
						/>
					</L2TabularListControl>
					{/* <L2TabularListControl>
						<L2TabularListControlLabel>Is Active</L2TabularListControlLabel>
						<L2ControlGrid layout={L2ControlGridLayout.FlexRow}>
							<L1Boolean
								inputType="radio"
								label="Yes"
								checked={model.Status == 'Active'}
								onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'Status', 'Active')}
							/>
							<L1Boolean
								inputType="radio"
								label="No"
								checked={model.Status == 'Inactive'}
								onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'Status', 'Inactive')}
							/>
							<L1Boolean
								inputType="radio"
								label="Unknown"
								checked={model.Status == 'Unknown'}
								onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'Status', 'Unknown')}
							/>
						</L2ControlGrid>
					</L2TabularListControl>
					<L2TabularListControl>
						<L2TabularListControlLabel>Date of Last Encounter</L2TabularListControlLabel>
						<L1TextField
							inputType="date"
							value={model.DateLastEncounter}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'DateLastEncounter', e.target.value)}
						/>
					</L2TabularListControl> */}
					<L2TabularListEditBreak />
					<L2TabularListControl>
						<L2TabularListControlLabel>Clinician Name</L2TabularListControlLabel>
						<L1TextField
							size={ComplexElementSize.Max}
							value={model.ClinicianName}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'ClinicianName', e.target.value)}
						/>
					</L2TabularListControl>
					<L2TabularListControl>
						<L2TabularListControlLabel>Speciality</L2TabularListControlLabel>
						<L1TextField
							size={ComplexElementSize.Max}
							value={model.Specialty}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'Specialty', e.target.value)}
						/>
					</L2TabularListControl>
					<L2TabularListControl>
						<L2TabularListControlLabel>Phone</L2TabularListControlLabel>
						<L1TextField
							size={ComplexElementSize.Medium}
							value={model.Phone ?? ''}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'Phone', e.target.value)}
						/>
					</L2TabularListControl>
					<L2TabularListEditBreak />
					<L2TabularListControl>
						<L2TabularListControlLabel>Street Address</L2TabularListControlLabel>
						<L1TextField
							value={model.Street1}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'Street1', e.target.value)}
							size={ComplexElementSize.Max}
						/>
					</L2TabularListControl>
					<L2TabularListControl>
						<L2TabularListControlLabel>Street Address 2</L2TabularListControlLabel>
						<L1TextField
							value={model.Street2}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'Street2', e.target.value)}
							size={ComplexElementSize.Max}
						/>
					</L2TabularListControl>
					<L2TabularListEditBreak />
					<L2TabularListControl>
						<L2TabularListControlLabel>City</L2TabularListControlLabel>
						<L1TextField
							value={model.City}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'City', e.target.value)}
						/>
					</L2TabularListControl>
					<L2TabularListControl>
						<L2TabularListControlLabel>State</L2TabularListControlLabel>
						<L1TextField
							value={model.State}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'State', e.target.value)}
							size={ComplexElementSize.Min}
						/>
					</L2TabularListControl>
					<L2TabularListControl>
						<L2TabularListControlLabel>Zip</L2TabularListControlLabel>
						<L1TextField
							value={model.Zip}
							onChange={(e: ChangeEvent<HTMLInputElement>) => updateModel(modelIdx, 'Zip', e.target.value)}
							size={ComplexElementSize.Min}
						/>
					</L2TabularListControl>
				</L2TabularListItemEdit>
			)
		} else {
			const lineWithBreak = (text?: string) => text && text.length > 0 ? (
				<>{text}<br/></>
			) : null
			return (
				<L2TabularListItemSummary
					key={modelIdx}
					onClick={() => setEditIdx(modelIdx)}
				>
					<div>{model.IsPCP ? 'Yes' : 'No'}</div>
					{/* <div>{model.Status}</div> */}
					<div>{model.ClinicianName}</div>
					<div>{model.Specialty}</div>
					<div>{model.Phone}</div>
					<div>
						{lineWithBreak(model.Street1)}
						{lineWithBreak(model.Street2)}
						{model.City}{model.City !== '' && model.State !== '' ? ',' : ''} {model.State} {model.Zip}
					</div>
				</L2TabularListItemSummary>
			)
		}
	})
	return (
		<L2TabularListRoot columnCount={5}>
			<L2TabularListHeader>
				<div>Is PCP</div>
				{/* <div>Status</div> */}
				<div>Clinician Name</div>
				<div>Specialty</div>
				<div>Phone</div>
				<div>Address</div>
			</L2TabularListHeader>
			<L2TabularListContent>
				{items}
			</L2TabularListContent>
			<L2TabularListActions>
				<L4NoPrint>
					<L1ReasonableButton icon={faPlus} label="Add" onClick={() => addModels([newPhysician()], true)} />
				</L4NoPrint>
			</L2TabularListActions>
		</L2TabularListRoot>
	)
}
